import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
export var ConfigContext = /*#__PURE__*/React.createContext({
  messages: []
});
export var ConfigConsumer = ConfigContext.Consumer;
var DataMaintainer = /*#__PURE__*/function () {
  function DataMaintainer() {
    _classCallCheck(this, DataMaintainer);
    _defineProperty(this, "tracker", void 0);
    _defineProperty(this, "trackerMap", void 0);
    this.tracker = null;
    this.trackerMap = new Map();
  }
  _createClass(DataMaintainer, [{
    key: "updateTracker",
    value: function updateTracker(tracker) {
      this.tracker = tracker;
    }
  }, {
    key: "addTrackerMap",
    value: function addTrackerMap(key, value) {
      this.trackerMap.set(key, value);
      console.log('addTrackerMap', key, value);
    }
  }, {
    key: "deleteTrackerMap",
    value: function deleteTrackerMap(key) {
      this.trackerMap.delete(key);
    }
  }, {
    key: "getTrackerMap",
    value: function getTrackerMap(key) {
      return this.trackerMap.get(key);
    }
  }]);
  return DataMaintainer;
}();
export var dataMaintainer = new DataMaintainer();